export default __webpack_public_path__ + "static/media/Sponsor_intro_2.cc78a832.png";